/*
 * @Author: EdwardYoung
 * @Date: 2017-07-25 23:09:58
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-08-23 00:54:14
 */

import axios from 'api/axios.js'
import {createApiHeader} from './createApiHeader.js'

function bargainForMyFriends (id) {
  return new Promise((resolve, reject) => {
    window.yhsd.ready(function (sdk) {
      sdk.account.current(function (User) {
        createApiHeader(axios, User.res.customer)
        _bargainForMyFriends(id, User.res.customer).then((res) => {
          resolve(res.data.data)
        }).catch((err) => {
          reject(err.response.data.message)
        })
      })
    })
  })
}

/**
 * 为朋友砍价
 */
function _bargainForMyFriends (id, customer) {
  const activityInfUrl = `/v1/front/play_records/${id}/help`
  return axios({
    method: 'POST',
    url: activityInfUrl,
    data: {
      avatar: customer.avatar_url,
      name: customer.name
    }
  })
}

export {bargainForMyFriends}



// WEBPACK FOOTER //
// ./src/api/bargainHelpFriends.js